/**
 * 支付渠道 SDK 依赖管理：集中维护 Payermax 与 Checus 的脚本地址及加载入口。
 */
import { loadScript } from './loadScript'

export const PAYERMAX_SDK_URL = 'https://cdn.payermax.com/dropin/js/pmdropin.min.js'

export const CHECUS_SDK_URL = import.meta.env.VITE_CHECUS_DROPIN_HREF

export class PaymentDependencyManager {
  /** 预加载支付渠道 SDK，供支付网站和组件 SDK 共用。 */
  async loadDependency() {
    return Promise.all([this.loadPayermax(), this.loadChecus()])
  }

  /** 加载 Payermax SDK。 */
  loadPayermax() {
    return loadScript(PAYERMAX_SDK_URL)
  }

  /** 加载 Checus SDK。国内环境未配置脚本地址时跳过，避免请求 undefined。 */
  loadChecus() {
    if (!CHECUS_SDK_URL) return Promise.resolve(true)
    return loadScript(CHECUS_SDK_URL)
  }
}
